// extracted by mini-css-extract-plugin
export default {"root":"ValueChainMapTableHeading_root__jHW6y","addButton":"ValueChainMapTableHeading_addButton__R4xY8","title":"ValueChainMapTableHeading_title__nKmiZ"};